<div class="login-back">
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">
              <img src="favicon.svg" width="32" style="margin-right: 5px" />{{
                appTitle
              }}
            </h5>
            <span class="card-sub-title" i18n="@@PasswordForgot_SubTitle"
              >Forgot your password?</span
            >
            <app-alert></app-alert>
            @if (form && !wasSuccesfull) {
              <form
                class="form-signin"
                [formGroup]="form"
                (ngSubmit)="OnSubmit()"
              >
                <div class="row">
                  <div class="col">
                    <frm-text
                      formControlName="email"
                      type="email"
                      i18n-label="@@PasswordForgot_Email"
                      label="E-Mail"
                    ></frm-text>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <ctrl-btn
                      style="width: 100%"
                      type="primary"
                      i18n-content="@@PasswordForgot_Submit"
                      content="Send password reset instructions"
                      (click)="OnSubmit()"
                      [disabled]="!form.valid"
                      [loading]="loading"
                    ></ctrl-btn>
                  </div>
                </div>
              </form>
            }
            <div class="row" style="padding-top: 20px">
              <div class="col">
                <a [routerLink]="'/login'" i18n="@@PasswordForgot_BackToLogin"
                  >Back to login</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="position: absolute; left: 0; bottom: 0; right: 0">
    <app-footer [dark]="true" />
  </div>
</div>
